import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDevicesStyle0 = cosmosIconCss;

const CosmosIconDevices$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDevices extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '18a1772eb2bea1633bc69dcf62a31b6ee74fc2a8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '26cb8c5da8391155e9aaba719c6d2f53c6136c2d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5873bbc6f9ade675e19ccf6458198611fe5c37d0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.5 13.5h-5v-8h14A.5.5 0 0 0 19 5v-.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V14a.5.5 0 0 0-.5-.5Zm3-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-7ZM16 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5-3h-5V9.5h5V15Zm-12 2.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-3Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDevicesStyle0; }
}, [1, "cosmos-icon-devices", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-devices"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-devices":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDevices$1);
            }
            break;
    } });
}

const CosmosIconDevices = CosmosIconDevices$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDevices, defineCustomElement };
